import {useIntl} from "@services/i18n"
import { ErrorFactoryUtils } from "./error-factory-utils";

export class AppError extends Error {
    private _area: string;
    private _errorCode: string;
    private _userAction: string;
    private _utcTime: string;
    private _details: any;
    private _handled: boolean = false;
    private _innnerError: Error | undefined;

    constructor(area: string, errorCode: string, userMessage: string, stack?: string | undefined, innerError?: Error) {
        super(userMessage);

        this._area = area;
        this._errorCode = errorCode;
        
        this._userAction = useIntl().i18n.t("shared.errors.errorTypes.appError.defaultUserAction");
        this._utcTime = new Date().toISOString();

        Object.setPrototypeOf(this, new.target.prototype);

        if (stack) {
            this.stack = stack;
        }

        this._innnerError = innerError;
    }

    public get area() {
        return this._area;
    }

    public get errorCode() {
        return this._errorCode;
    }

    public get userAction() {
        return this._userAction;
    }

    public set userAction(value: string) {
        this._userAction = value;
    }

    public get utcTime() {
        return this._utcTime;
    }

    public get isAppError() {
        return true;
    }

    public get details() {
        return this._details;
    }

    public set details(value: any) {
        this._details = value;
    }

    public get errorType() {
        return this.constructor.name;
    }

    public get handled() {
        return this._handled;
    }

    public set handled(value: boolean) {
        this._handled = value;
    }

    public get innerError() {
        return this._innnerError;
    }

    protected prepareForJson(): any {
        return {
            errorType:this.errorType,
            area: this.area,
            errorCode: this.errorCode,
            message: this.message,
            userAction: this.userAction,
            utcTime: this.utcTime,
            details: this.details,
            stack: this.stack,
            inner: this.innerError instanceof AppError 
            ? this.innerError.prepareForJson() 
            : (this.innerError ? {message: ErrorFactoryUtils.getExceptionMessage(this.innerError), stack: this.innerError.stack} : undefined)
        };                
    }

    public toJson(): string {
        return JSON.stringify(this.prepareForJson(), null, 2);
    }
}